module.exports = __webpack_public_path__ + "img/interior_11.68b77fdf.jpg";